// AUTO-GENERATED SQL Builder (V40 Final) for Blacklist
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BlacklistSql {
  private ast = new SqlAst('Blacklist', 'blacklist');
  public readonly main: any = {};

  public guid: SqlField;
  public name: SqlField;
  public ssmNo: SqlField;
  public icNo: SqlField;
  public bankAccountNo: SqlField;
  public reportedVendorId: SqlField;
  public reason: SqlField;
  public createdByUser: SqlNavHybrid;
  public reportedVendor: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('blacklist', 'guid', '', 'id', 'blacklist_guid');
    this.name = new SqlField('blacklist', 'name', '', 'id', 'blacklist_name');
    this.ssmNo = new SqlField('blacklist', 'ssmNo', '', 'id', 'blacklist_ssmNo');
    this.icNo = new SqlField('blacklist', 'icNo', '', 'id', 'blacklist_icNo');
    this.bankAccountNo = new SqlField('blacklist', 'bankAccountNo', '', 'id', 'blacklist_bankAccountNo');
    this.reportedVendorId = new SqlField('blacklist', 'reportedVendorId', '', 'id', 'blacklist_reportedVendor');
    this.reason = new SqlField('blacklist', 'reason', '', 'id', 'blacklist_reason');
    this.createdByUser = createNavHybrid('blacklist', 'blacklist_createdByUser', 'User');
    this.reportedVendor = createNavHybrid('blacklist', 'blacklist_reportedVendor', 'Vendor');
    this.updatedByUser = createNavHybrid('blacklist', 'blacklist_updatedByUser', 'User');
    this.id = new SqlField('blacklist', 'id', '', 'id', 'blacklist_id');
    this.isDeleted = new SqlField('blacklist', 'isDeleted', '', 'id', 'blacklist_isDeleted');
    this.createdBy = new SqlField('blacklist', 'createdBy', '', 'id', 'blacklist_createdBy');
    this.createdDate = new SqlField('blacklist', 'createdDate', '', 'id', 'blacklist_createdDate');
    this.updatedBy = new SqlField('blacklist', 'updatedBy', '', 'id', 'blacklist_updatedBy');
    this.updatedDate = new SqlField('blacklist', 'updatedDate', '', 'id', 'blacklist_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BlacklistSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BlacklistSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BlacklistSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BlacklistSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BlacklistSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BlacklistSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BlacklistSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BlacklistSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BlacklistSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BlacklistSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
